// Root UI renderer file
<template>
  <loader id="loader" class="hidden"></loader>
  <Header />
  <router-view />
  <Footer />
</template>

<script>
import Header from "./components/Layout/Header.vue";
import Footer from "./components/Layout/Footer.vue";
import Loader from "./components/Layout/Form/Loader.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    Loader
  },
  data() {
    return {
      form: {
        name: "",
        company: "",
        email: "",
        mobile: "",
        message: ""
      }
    };
  },
  mounted() {
    let leadData = JSON.parse(localStorage.getItem("leadData"));
    let attData = JSON.parse(localStorage.getItem("att_data"));
    let attorneyData = JSON.parse(localStorage.getItem("attorney_data"));
    let tempAttData = JSON.parse(localStorage.getItem("tempAttData"));
    if (
      leadData != undefined &&
      leadData != "" &&
      leadData != null &&
      leadData != []
    ) {
      this.$store.dispatch("setLeadData");
    }
    if (
      attorneyData != undefined &&
      attorneyData != "" &&
      attorneyData != null &&
      attorneyData != []
    ) {
      this.$store.dispatch("setAttorneyData");
    }
    if (
      attData != undefined &&
      attData != "" &&
      attData != null &&
      attData != []
    ) {
      this.$store.dispatch("setAttData");
    }
    if (
      tempAttData != undefined &&
      tempAttData != "" &&
      tempAttData != null &&
      tempAttData != []
    ) {
      this.$store.dispatch("settempAttData");
    }
  }
};
</script>
